import React from "react"
import { css } from "@emotion/core"

type LogoProps = { size?: number | string; plain?: boolean; color?: string }

export default function Logo({
  size = 100,
  plain = false,
  color = "#111319",
  ...props
}: LogoProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        display: "block",
        margin: "0 auto",
      }}
      {...props}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 470 470"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        {!plain && (
          <rect
            fill={color}
            x="0"
            y="0"
            width="470"
            height="470"
            rx="84"
          ></rect>
        )}
        {!plain && (
          <path
            fill="#fff"
            d="M128.625,147 L200.875,147 L284.125,313.5 L341.5,313.5 L341.5,332 L269.125,332 L185.875,165.5 L128.625,165.5 L128.625,147 Z M255,147 L341.5,147 L341.5,165.5 L255,165.5 L255,147 Z"
          ></path>
        )}
        {plain && (
          <path
            fill={color}
            d="M128.625,147 L200.875,147 L284.125,313.5 L341.5,313.5 L341.5,332 L269.125,332 L185.875,165.5 L128.625,165.5 L128.625,147 Z M255,147 L341.5,147 L341.5,165.5 L255,165.5 L255,147 Z"
          ></path>
        )}
      </svg>
    </div>
  )
}
